// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hrsata-jobs .online-test-management-view .excluded-question[data-v-189f8b74],.hrsata-jobs .single-job-ad-view .excluded-question[data-v-189f8b74]{opacity:.8;border-color:var(--v-error-lighten3)!important}.hrsata-jobs .online-test-management-view .included-question[data-v-189f8b74],.hrsata-jobs .single-job-ad-view .included-question[data-v-189f8b74]{border-color:var(--v-success-lighten3)!important}", ""]);
// Exports
module.exports = exports;
